/**
 * Push Notification Widget
 * Integrates push notification modal with user context
 */

import { NotificationPermissionModal } from '@/shared/features/push-notification';

/**
 * Push Notification Widget
 * Shows notification permission modal and handles user context integration
 * 
 * Note: User context (customerId/visitorId) is optional for push notifications.
 * The subscription will work without them, and backend can match by device token.
 */
export function PushNotificationWidget() {
  return (
    <NotificationPermissionModal
      showDelay={2000} // Show after 2 seconds
      onAllow={(token) => {
        if (token) {
          console.log('Push notification enabled, token:', token.substring(0, 20) + '...');
        }
      }}
      onDeny={() => {
        console.log('Push notification permission dismissed');
      }}
    />
  );
}
